export class WhmcsStats {

    public result: string;
    public incomeToday: string;
    public incomeThisMonth: string;
    public incomeThisYear: string;
    public networkIssuesOpen: number;
    public ordersPending: number;
    public ticketsOpen: number;
    public cancellationsPending: number;
    public staffOnline: number;

    public static emptyWhmcsStats(): WhmcsStats {
        return new WhmcsStats('', '', '', 0, 0, 0, 0, 0);
    }

    constructor(incomeToday: string, incomeThisMonth: string, incomeThisYear: string, networkIssuesOpen: number, ordersPending: number, ticketsOpen: number, cancellationsPending: number, staffOnline: number) {
        this.incomeToday = incomeToday;
        this.incomeThisMonth = incomeThisMonth;
        this.incomeThisYear = incomeThisYear;
        this.networkIssuesOpen = networkIssuesOpen;
        this.ordersPending = ordersPending;
        this.ticketsOpen = ticketsOpen;
        this.cancellationsPending = cancellationsPending;
        this.staffOnline = staffOnline
    }

}
